import React from "react";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { IconButton } from "@mui/material";

import { CollapseButtonContainer } from "./LeftSidebarCollapseButton.styles";

interface LeftSidebarCollapseButtonProps {
  isCollapsed: boolean;
  onToggle: () => void;
}

/**
 * Collapse/expand button for the left sidebar.
 * Shows ChevronLeft when expanded, ChevronRight when collapsed.
 */
const LeftSidebarCollapseButton: React.FC<LeftSidebarCollapseButtonProps> = ({ isCollapsed, onToggle }) => {
  return (
    <CollapseButtonContainer $isCollapsed={isCollapsed}>
      <IconButton
        size="small"
        onClick={onToggle}
        aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
        data-testid="left-sidebar-collapse-button"
        sx={{
          width: 22,
          height: 22,
          padding: 0,
          transition: "color 0.2s ease-in-out",
        }}
      >
        {isCollapsed ? <ChevronRight fontSize="small" /> : <ChevronLeft fontSize="small" />}
      </IconButton>
    </CollapseButtonContainer>
  );
};

export default LeftSidebarCollapseButton;
